import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnInit,
  ViewEncapsulation,
} from '@angular/core';
import {
  DetailProductListWithApplicationTime,
  ProductWithApplicationTime,
} from '../../../model/detail-questions.model';
import { ProductProposal } from '../../../../../../../../shared/model/product-proposal';
import { AreaChangeDetection } from '../../area-change-detection.service';
import { ProductProposalService } from '../../../../../../../../shared/service/product-proposal.service';

@Component({
  selector: 'hpm-product-with-application-time',
  templateUrl: './product-with-application-time.component.html',
  styleUrl: './product-with-application-time.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  // we need to modify mat form field
  encapsulation: ViewEncapsulation.None,
})
export class ProductWithApplicationTimeComponent implements OnInit {
  @Input() hygieneInspectionDisabled = false;
  @Input() detail!: DetailProductListWithApplicationTime;
  @Input() area!: string;
  @Input() questionId!: string;
  productProposals: (ProductProposal | undefined)[] = [];

  constructor(
    private productProposalService: ProductProposalService,
    private areaChangeDetection: AreaChangeDetection,
  ) {}

  ngOnInit(): void {
    this.ensureInputNotEmpty(true);
  }

  private ensureInputNotEmpty(initialization: boolean): void {
    if (this.detail.products.length === 0) {
      const defaultProduct = this.productProposalService.getDefaultProduct(
        this.area,
        this.questionId,
      );
      if (initialization && defaultProduct) {
        this.detail.products.push(this.getDefaultItem(defaultProduct));
        this.productProposals.push(defaultProduct);
      } else {
        this.detail.products.push({ product: '', applicationTime: '' });
        this.productProposals = new Array(this.detail.products.length);
      }
    }
  }

  private getDefaultItem(
    proposal: ProductProposal,
  ): ProductWithApplicationTime {
    let dose = proposal.doses?.find((d) => d.isDefaultDose)?.dose;

    if (!dose) {
      dose = '';
    }

    return {
      product: proposal.name,
      applicationTime: dose,
    };
  }

  addLine(index: number): void {
    this.detail.products.splice(index + 1, 0, {
      product: '',
      applicationTime: '',
    });
    this.productProposals.splice(index + 1, 0, undefined);
    this.areaChangeDetection.onChange();
  }

  removeLine(index: number): void {
    this.detail.products.splice(index, 1);
    this.productProposals.splice(index, 1);
    this.ensureInputNotEmpty(false);
    this.areaChangeDetection.onChange();
  }

  onProductProposalSelected(index: number, proposal: ProductProposal): void {
    this.productProposals[index] = proposal;
  }
}
